/**
 * Проверяет, является ли значение простым объектом (не массив и не null).
 *
 * @param value - Значение для проверки
 * @returns Флаг, что значение — простой объект
 */
export const isPlainObject = (value: unknown): value is object =>
  typeof value === 'object' && value !== null && !Array.isArray(value);
